import React from 'react';


export default function Logo(props) {
    return (

        <div className="row">
          <img
            id="logo-lucree"
            alt={props.img}
            src={props.img}>
          </img>
        </div>


    )
}
